var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"context-menu-option",class:{'hoverable-item': !_vm.disabled, 'disabled-item': _vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.handle_click.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }